import { LinkHub, LinkHubSkeleton } from "@/components";
import { PLATFORM_LANDING_FOOTER, PLATFORM_TENANT_SLUG } from "@/constants";
import { useLinkHubLanding } from "@/hooks";

const Landing: React.FC = () => {
  const { config, loading, error } = useLinkHubLanding({
    slug: PLATFORM_TENANT_SLUG,
  });

  if (loading) {
    return (
      <div className="container">
        <LinkHubSkeleton />
      </div>
    );
  }

  if (error || !config) {
    return (
      <div className="container">
        <p>{error?.message ?? "No se pudo cargar el sitio."}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <LinkHub config={config} />
      <div className="landing__footer">
        <p>{PLATFORM_LANDING_FOOTER}</p>
      </div>
    </div>
  );
};

export default Landing;